import { render, staticRenderFns } from "./JudgementTemplateSelectTab.vue?vue&type=template&id=86a8d7da&scoped=true&lang=pug"
import script from "./JudgementTemplateSelectTab.vue?vue&type=script&lang=ts"
export * from "./JudgementTemplateSelectTab.vue?vue&type=script&lang=ts"
import style0 from "./JudgementTemplateSelectTab.vue?vue&type=style&index=0&id=86a8d7da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a8d7da",
  null
  
)

export default component.exports